<div *ngIf="inModal" class="modal-header">
    <div class="ml-3 mt-3"><strong>Information by various teams</strong></div>

    <button type="button" (click)="close()" class="btn-close" aria-label="Close"></button>

</div>
<div [ngClass]="{'modal-body': inModal}" class="accordion">
    <div [ngClass]="{'container  mb-3 scrollable': inModal}">
        <div ngbAccordion #accordion="ngbAccordion">
            <ng-container *ngFor="let step of steps; let index = index; let first = first;">
                <ng-container
                    *ngIf="(step.role != 'GuidanceMail') || (step.role == 'GuidanceMail' && isMailSameOrExitTeam)">
                    <div ngbAccordionItem *eosViewTeamInfo="step.role" id="panel-{{index}}">
                        <div ngbAccordionToggle (click)="toggle(index)"  class="accordion-button custom-header justify-content-between">
                            <div  class="d-flex align-items-center">
                                <img [src]="isOpen(index) ? 'design/images/minus.png' : 'design/images/plus.png'"
                                    alt="Toggle Icon" class="resize" />
                                <div class="mx-2"><b>{{step.label}}</b></div>
                                 </div>
                                        <div class="ms-auto px-4 py-1 status-badge" [ngClass]="{'completed': model[step.teamInfoprop]?.submittedStatus === 'Completed',
                                                 'inprogress': model[step.teamInfoprop]?.submittedStatus === 'Inprogress',
                                                'not-started': model[step.teamInfoprop]?.submittedStatus === null }">

                                            {{model[step.teamInfoprop]?.submittedStatus ?
                                            model[step.teamInfoprop]?.submittedStatus :
                                            "Not started" }}
                                        </div>
                                    

                                
                           
                        </div>
                        <div ngbAccordionCollapse>
                            <div ngbAccordionBody>
                                <ng-template>
                                  <formly-form [form]="formArray.at(index)" [fields]="step.fields" [model]="model">
                            </formly-form>
                            <ng-container *ngIf="step.showFileUpload">
                                <!-- <ng-template *ngTemplateOutlet="fileUpload"></ng-template> -->
                                <div class="row mb-3">
                                    <div class="col-md-4" style="background-color:#D7D7D7; font-weight:600;">
                                        Document upload is not mandatory for submission.
                                    </div>

                                </div>
                                <eos-exit-file-upload
                                    [readonly]="!step.enableSaveAndSubmit || (!(model[step.teamInfoprop] && !model[step.teamInfoprop].submittedDate) && !isExitTeam) || profileCompleted"
                                    [moduleType]="step.docType" [isExitTeam]="false" [exitType]="exitType"
                                    [readonly]="false" [model]="model" (validDocuments)="setValidDocuments($event)"
                                    (GetDocumentEvent)="GetDocuments($event)" [showingFileUpload]="true">
                                </eos-exit-file-upload>
                            </ng-container>
                            <a class="btn btn-outline-primary me-2 mt-3" eosDebounce (debounceClick)="save(step,index)"
                                *ngIf="(showSave 
                            && step.enableSaveAndSubmit
                            && (model[step.teamInfoprop] && !model[step.teamInfoprop].submittedDate))
                            && !isExitTeam
                            && !profileCompleted">
                                Save
                            </a>
                            <button
                                *ngIf="(step.enableSaveAndSubmit && (model[step.teamInfoprop] && !model[step.teamInfoprop].submittedDate) && !profileCompleted) || enableSubmit"
                                eosDebounce class="btn btn-secondary me-2 mt-3" (debounceClick)="submit(step,index)"
                                [disabled]="(model[step.role.toLowerCase()]?.submittedStatus === 'Completed' && !isExitTeam) || (isCWTeam &&  model[step.teamInfoprop]?.submittedStatus === 'Completed')">
                                Submit
                            </button>
  
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>

    </div>

</div>